// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","container":"_2nQe6","summary":"CALUr","allInformations":"_2V6DT","title":"_3ZRdf"};